// ============================================================
//  src/components/layout/BottomNav.js
// ============================================================
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './BottomNav.css';

export default function BottomNav() {
  const { user } = useAuth();

  const navItems = [
    { to: '/dashboard',    icon: 'fa-house',        label: 'Home'     },
    { to: '/services',     icon: 'fa-grip',             label: 'Services' },
    { to: '/transactions', icon: 'fa-clock-rotate-left', label: 'History' },
    { to: '/referral',       icon: 'fa-wallet',       label: 'Wallet'   },
    { to: '/profile',      icon: 'fa-circle-user',  label: 'Profile'  },
  ];

  return (
    <nav className="bottom-nav">
      <div className="bottom-nav-inner">
        {navItems.map(({ to, icon, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) => `bn-item${isActive ? ' active' : ''}`}
          >
            <i className={`fas ${icon} bn-icon`} />
            <span className="bn-label">{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}